import { normalize, schema } from 'normalizr';

const options = {
  idAttribute: 'reference'
};
export const consumption = new schema.Entity('consumption', {}, options);
export const billing = new schema.Entity('billing', {}, options);

export default (data, schema) => normalize(data, [schema]);
